/**
 * Product Card Navigation & Video - Loaded once for all cards
 * Extracted from product-card.liquid for performance
 */
(function() {
  if (window.__productCardNavInitialized) return;
  window.__productCardNavInitialized = true;

  var VIDEO_CONFIG = {
    DELAY: 0,
    INTERSECTION_THRESHOLD: 0.4,
    ROOT_MARGIN: '100px'
  };

  var videoObserver = null;

  function initVideoIntersectionObserver() {
    var videoWrappers = document.querySelectorAll('.video-wrapper');

    if (!('IntersectionObserver' in window) || videoWrappers.length === 0) {
      return null;
    }

    if (videoObserver) {
      videoWrappers.forEach(function(wrapper) {
        if (!wrapper.dataset.videoObserved) {
          videoObserver.observe(wrapper);
          wrapper.dataset.videoObserved = 'true';
        }
      });
      return videoObserver;
    }

    var observerOptions = {
      root: null,
      rootMargin: VIDEO_CONFIG.ROOT_MARGIN,
      threshold: VIDEO_CONFIG.INTERSECTION_THRESHOLD
    };

    videoObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        var wrapper = entry.target;
        var video = wrapper.querySelector('.product-card-video');
        var state = wrapper.getAttribute('data-video-state');

        var container = wrapper.closest('.product-media-container');
        var hasVideo = container && container.getAttribute('data-has-video') === 'true';

        if (!hasVideo) return;
        if (wrapper.dataset.processing === 'true') return;

        if (entry.isIntersecting) {
          if (state === 'idle') {
            wrapper.dataset.processing = 'true';
            wrapper.setAttribute('data-video-state', 'loading');

            if (video) {
              video.load();

              var onCanPlay = function() {
                wrapper.setAttribute('data-video-state', 'playing');
                video.play().catch(function() {});
                wrapper.dataset.processing = 'false';
                video.removeEventListener('canplay', onCanPlay);
              };

              video.addEventListener('canplay', onCanPlay);

              setTimeout(function() {
                if (wrapper.getAttribute('data-video-state') === 'loading') {
                  onCanPlay();
                }
              }, 2000);
            }
          } else if (state === 'playing' && video && video.paused) {
            video.play().catch(function() {});
          }
        } else {
          if (video && !video.paused) {
            video.pause();
          }
        }
      });
    }, observerOptions);

    videoWrappers.forEach(function(wrapper) {
      videoObserver.observe(wrapper);
      wrapper.dataset.videoObserved = 'true';
    });

    return videoObserver;
  }

  function initProductImageNavigation() {
    var productCards = document.querySelectorAll('product-card');

    productCards.forEach(function(card) {
      if (card.dataset.navInitialized) return;
      card.dataset.navInitialized = 'true';

      var container = card.querySelector('.product-media-container');
      if (!container) return;

      var totalImages = parseInt(container.dataset.productImages) || 0;
      if (totalImages <= 1) return;

      var slides = container.querySelectorAll('.image-slide');
      var leftZone = container.querySelector('.nav-zone--left');
      var rightZone = container.querySelector('.nav-zone--right');
      var centerZone = container.querySelector('.center-click-zone');

      if (slides.length <= 1) return;

      var currentIndex = 0;
      var isAnimating = false;

      function showImage(index) {
        if (index === currentIndex || isAnimating) return;

        isAnimating = true;

        slides.forEach(function(slide, i) {
          slide.classList.toggle('active', i === index);
        });

        currentIndex = index;

        var videoWrapper = slides[0].querySelector('.video-wrapper');
        if (videoWrapper && index !== 0) {
          var video = videoWrapper.querySelector('.product-card-video');
          if (video && !video.paused) {
            video.pause();
          }
        }

        setTimeout(function() {
          isAnimating = false;
        }, 300);
      }

      if (leftZone) {
        leftZone.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var newIndex = currentIndex === 0 ? slides.length - 1 : currentIndex - 1;
          showImage(newIndex);
        });
      }

      if (rightZone) {
        rightZone.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var newIndex = currentIndex === slides.length - 1 ? 0 : currentIndex + 1;
          showImage(newIndex);
        });
      }

      if (centerZone) {
        centerZone.addEventListener('click', function(e) {
          e.preventDefault();
          var activeSlide = slides[currentIndex];
          var link = activeSlide ? activeSlide.querySelector('.image-link, .video-link') : null;
          if (link) {
            window.location.href = link.href;
          }
        });
      }
    });
  }

  function init() {
    initProductImageNavigation();
    initVideoIntersectionObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('facets:updated', function() {
    setTimeout(init, 500);
  });

  if (window.MutationObserver) {
    var observer = new MutationObserver(function(mutations) {
      var hasNewCards = false;
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.matches && node.matches('product-card') || node.querySelector && node.querySelector('product-card'))) {
            hasNewCards = true;
          }
        });
      });
      if (hasNewCards) setTimeout(init, 100);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
